import { FC } from 'react'

import { Text, TextProps } from '@hhgtech/hhg-components/mantine'

import { useIsMobile } from 'hooks/useIsMobile'

const FeatureCardHeading: FC<TextProps> = ({ children, ...rest }) => {
  const isMobile = useIsMobile()
  return (
    <Text
      size={isMobile ? 'h4' : 'h2'}
      as="h2"
      variant="primary"
      weight="halfBold"
      {...rest}
    >
      {children}
    </Text>
  )
}

FeatureCardHeading.displayName = 'FeatureCardHeading'

export default FeatureCardHeading
